module.exports = __webpack_public_path__ + "img/failed.2028e3a6.jpg";